/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_Stat_Domain_RatingInputs */

const en_directory_home_hero_stat_domain_rating = /** @type {(inputs: Directory_Home_Hero_Stat_Domain_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`domain rating`)
};

const zh_directory_home_hero_stat_domain_rating = /** @type {(inputs: Directory_Home_Hero_Stat_Domain_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`域名评分`)
};

/**
* | output |
* | --- |
* | "domain rating" |
*
* @param {Directory_Home_Hero_Stat_Domain_RatingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_stat_domain_rating = /** @type {((inputs?: Directory_Home_Hero_Stat_Domain_RatingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_Stat_Domain_RatingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_stat_domain_rating(inputs)
	return zh_directory_home_hero_stat_domain_rating(inputs)
});
export { directory_home_hero_stat_domain_rating as "directory.home.hero.stat_domain_rating" }